'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'hurricane';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'f751';
var svgPathData = 'M181.4 1.7C200.9-.8 216 15.1 216 32.8l.1 66.1c95.2 19.1 167.9 103.7 167.9 204.5 0 105.9-79.1 193.2-181.4 206.3-19.5 2.5-34.6-13.4-34.6-31.1 0-11.7-.1-66.1-.1-66.1-95.2-19.1-167.9-103.7-167.9-204.5 0-105.9 79.1-193.2 181.4-206.3zM32 208c0 85.3 60.7 156.4 141.2 172.6 14.7 2.9 26.8 15.7 26.8 32.1l0 65.1c85.8-11.7 152-85.3 152-174.4 0-85.3-60.7-156.4-141.2-172.6-14.7-2.9-26.8-15.7-26.8-32.1l0-65.1C98.2 45.3 32 118.9 32 208zm112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHurricane = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;